import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Sheet, SheetContent, SheetHeader } from "@/components/ui/sheet";
import { TrainingEntity } from "@/interfaces/employee.interface";
import { dateFormat } from "@/utils/helper-functions/date-time.helper";

interface TicketSheetProps {
  isOpen: boolean;
  toggleOpen: () => void;
}

const TicketSheet = ({
  isOpen,
  toggleOpen,
}: TicketSheetProps): React.ReactElement => {
  const tickets: TrainingEntity[] = JSON.parse(
    localStorage.getItem("tickets") || "[]",
  );

  const handleExit = (): void => {
    toggleOpen();
    localStorage.removeItem("tickets");
  };

  return (
    <Sheet open={isOpen} onOpenChange={handleExit}>
      <SheetContent className='pt-12 sm:max-w-[400px] lg:max-w-[480px] '>
        <SheetHeader>
          <h1 className='mb-5 text-2xl font-medium'>Tickets</h1>
        </SheetHeader>
        <ScrollArea className=' max-h-[90vh] overflow-y-scroll scrollbar-none'>
          {tickets.map((ticket, index) => (
            <Card key={index} className='mb-4'>
              <CardHeader>
                <h2>{ticket?.name}</h2>
                <p className='text-sm '>
                  Issued Date: {dateFormat(ticket?.issuedDate, "MMM d, yyyy")}
                </p>
                <p className='text-sm '>
                  Expiry Date: {dateFormat(ticket?.expiryDate, "MMM d, yyyy")}
                </p>
              </CardHeader>
              <CardContent>
                <img
                  src={ticket?.ticketUrl}
                  alt='certificate'
                  className='object-cover w-full h-40 rounded-md'
                />
              </CardContent>
            </Card>
          ))}
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};

export default TicketSheet;
